module.exports = __webpack_public_path__ + "static/media/cuisine_HR.88c4e08e.jpg";